<template>
  <div class="w-100">
    <label>{{ $t('security.pinInputText') }}</label>
    <b-form-input
      id="pin"
      ref="pinInput"
      v-model="pin"
      name="pin"
      type="tel"
      pattern="[0-9]"
      maxlength="8"
      class="pin_mask"
      :placeholder="$t('security.pinPlaceHolder')"
    />
    <b-alert v-show="showPinError" fade show variant="danger">
      <small>{{ $t('security.pinIsInvalid') }}</small>
    </b-alert>
  </div>
</template>

<script>
import Vue from "vue";
export default Vue.extend({
  name: "PinInput",
  props: {
    showPinError: Boolean
  },
  data() {
    return {
      pin: ""
      //showPinError: false
    };
  },
  methods: {
    showInputError() {
      this.showPinError = true;
      setTimeout(() => {
        this.showPinError = false;
      }, 5000);
    }
  }
});
</script>
